import React, { useState } from "react";
import { IoIosArrowDropright, IoIosArrowDropleft } from "react-icons/io";
import { FaRegUser, FaPowerOff } from "react-icons/fa";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Drawer } from "antd";
import DashboardMenu from "./DashboardMenu";
import { logoutAdmin } from "../../redux/admin/adminSlice";

const DashBoard_Header = ({ menubar_Status, get_menu_status }) => {
  const { loginData } = useSelector((state) => state.admin || {});
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logoutAdmin());
    navigate("/");
  };

  return (
    <div className="dashboard_header_container">
      <div className={menubar_Status ? "closeheader_dash" : "openheader_dash"} style={{paddingTop:"5px", backgroundColor:"#fff"}}>
        <img src={menubar_Status ? "/61.svg" : "/dhruva.webp"} alt="admin logo" />
      </div>
      
      <div className={menubar_Status ? "close_body_header_dash" : "open_body_header_dash"}>
        <div className="body_heare_left">
          {menubar_Status ? (
            <IoIosArrowDropright className="icon_tobler cursor_po" onClick={() => get_menu_status(true)} />
          ) : (
            <IoIosArrowDropleft className="icon_tobler cursor_po" onClick={() => get_menu_status(false)} />
          )}
        </div>
        
        <div className="body_heare_right">
          <span className="username_hed">
            <FaRegUser className="mx-1" />
            {loginData?.firstname} {loginData?.lastname}
          </span>
          
          <span className="username_hed cursor_po" onClick={handleLogout}>
            <FaPowerOff className="mx-1" /> Logout
          </span>
          
          <span className="username_hed_mobile cursor_po" onClick={() => setOpen(true)}>
            <HiOutlineMenuAlt3 className="mx-0" />
          </span>
        </div>
      </div>
      
      <Drawer placement="right" size="378px" onClose={() => setOpen(false)} open={open}>
        <DashboardMenu onClose={() => setOpen(false)} />
      </Drawer>
    </div>
  );
};

export default DashBoard_Header;